import Radium from 'radium';
import {
  fadeIn,
  slideInDown,
  bounce
} from 'react-animations';

/**
 * @constant {Object} ActionTypes
 */
export const ActionTypes = {
  FETCH_CATEGORIAS_REQUEST: 'FETCH_CATEGORIAS_REQUEST',
  FETCH_CATEGORIAS_SUCCESS: 'FETCH_CATEGORIAS_SUCCESS',
  FETCH_CATEGORIAS_FAILURE: 'FETCH_CATEGORIAS_FAILURE',

  FETCH_VERSION_REQUEST: 'FETCH_VERSION_REQUEST',
  FETCH_VERSION_SUCCESS: 'FETCH_VERSION_SUCCESS',
  FETCH_VERSION_FAILURE: 'FETCH_VERSION_FAILURE',

  FETCH_VERSION_COLOR_INFO_REQUEST: 'FETCH_VERSION_COLOR_INFO_REQUEST',
  FETCH_VERSION_COLOR_INFO_FAILURE: 'FETCH_VERSION_COLOR_INFO_FAILURE',
  FETCH_VERSION_COLOR_INFO_SUCCESS: 'FETCH_VERSION_COLOR_INFO_SUCCESS',

  SELECT_ACCESSORY_REQUEST: 'SELECT_ACCESSORY_REQUEST',
  SELECT_ACCESSORY_SUCCESS: 'SELECT_ACCESSORY_SUCCESS',
  SELECT_ACCESSORY_FAILURE: 'SELECT_ACCESSORY_FAILURE',

  SELECT_MAINTENANCE_REQUEST: 'SELECT_MAINTENANCE_REQUEST',
  SELECT_MAINTENANCE_SUCCESS: 'SELECT_MAINTENANCE_SUCCESS',
  SELECT_MAINTENANCE_FAILURE: 'SELECT_MAINTENANCE_FAILURE',

  CHOOSE_INSURANCE_REQUEST: 'CHOOSE_INSURANCE_REQUEST',
  CHOOSE_INSURANCE_SUCCESS: 'CHOOSE_INSURANCE_SUCCESS',
  CHOOSE_INSURANCE_FAILURE: 'CHOOSE_INSURANCE_FAILURE',

  CHANGE_PRIME_PERCENTAGE_REQUEST: 'CHANGE_PRIME_PERCENTAGE_REQUEST',
  CHANGE_PRIME_PERCENTAGE_SUCCESS: 'CHANGE_PRIME_PERCENTAGE_SUCCESS',
  CHANGE_PRIME_PERCENTAGE_FAILURE: 'CHANGE_PRIME_PERCENTAGE_FAILURE',

  CHOOSE_FINANCING_OPTION_REQUEST: 'CHOOSE_FINANCING_OPTION_REQUEST',
  CHOOSE_FINANCING_OPTION_SUCCESS: 'CHOOSE_FINANCING_OPTION_SUCCESS',
  CHOOSE_FINANCING_OPTION_FAILURE: 'CHOOSE_FINANCING_OPTION_FAILURE',

  FETCH_TEST_DRIVE_INFO_REQUEST: 'FETCH_TEST_DRIVE_INFO_REQUEST',
  FETCH_TEST_DRIVE_INFO_SUCCESS: 'FETCH_TEST_DRIVE_INFO_SUCCESS',
  FETCH_TEST_DRIVE_INFO_FAILURE: 'FETCH_TEST_DRIVE_INFO_FAILURE',

  FETCH_TEST_DRIVE_RSVP_REQUEST: 'FETCH_TEST_DRIVE_RSVP_REQUEST',
  FETCH_TEST_DRIVE_RSVP_SUCCESS: 'FETCH_TEST_DRIVE_RSVP_SUCCESS',
  FETCH_TEST_DRIVE_RSVP_FAILURE: 'FETCH_TEST_DRIVE_RSVP_FAILURE',

  FETCH_AVALUOS_REQUEST: 'FETCH_AVALUOS_REQUEST',
  FETCH_AVALUOS_SUCCESS: 'FETCH_AVALUOS_SUCCESS',
  FETCH_AVALUOS_FAILURE: 'FETCH_AVALUOS_FAILURE',

  GET_AVALUO_REQUEST: 'GET_AVALUO_REQUEST',
  GET_AVALUO_SUCCESS: 'GET_AVALUO_SUCCESS',
  GET_AVALUO_FAILURE: 'GET_AVALUO_FAILURE',

  SEND_AVALUO_REQUEST: 'SEND_AVALUO_REQUEST',
  SEND_AVALUO_SUCCESS: 'SEND_AVALUO_SUCCESS',
  SEND_AVALUO_FAILURE: 'SEND_AVALUO_FAILURE',

  REQUEST_TEST_DRIVE_REQUEST: 'REQUEST_TEST_DRIVE_REQUEST',
  REQUEST_TEST_DRIVE_SUCCESS: 'REQUEST_TEST_DRIVE_SUCCESS',
  REQUEST_TEST_DRIVE_FAILURE: 'REQUEST_TEST_DRIVE_FAILURE',
  REQUEST_TEST_DRIVE_RESET: 'REQUEST_TEST_DRIVE_RESET',

  FETCH_RESERVATION_REQUEST: 'FETCH_RESERVATION_REQUEST',
  FETCH_RESERVATION_SUCCESS: 'FETCH_RESERVATION_SUCCESS',
  FETCH_RESERVATION_FAILURE: 'FETCH_RESERVATION_FAILURE',
  FETCH_RESERVATION_RESET: 'FETCH_RESERVATION_RESET',

  SEND_COTIZACION_REQUEST: 'SEND_COTIZACION_REQUEST',
  SEND_COTIZACION_SUCCESS: 'SEND_COTIZACION_SUCCESS',
  SEND_COTIZACION_FAILURE: 'SEND_COTIZACION_FAILURE',

  CHANGE_PLAZO_REQUEST: 'CHANGE_PLAZO_REQUEST',
  CHANGE_PLAZO_SUCCESS: 'CHANGE_PLAZO_SUCCESS',
  CHANGE_PLAZO_FAILURE: 'CHANGE_PLAZO_FAILURE',

  SAVE_INITIAL_QUERYPARAMS: 'SAVE_INITIAL_QUERYPARAMS',

  REQUEST_CLIENT_INFO: 'REQUEST_CLIENT_INFO',
  REQUEST_CLIENT_SUCCESS: 'REQUEST_CLIENT_SUCCESS',
  REQUEST_CLIENT_FAILURE: 'REQUEST_CLIENT_FAILURE',

  REQUEST_COUPON: 'REQUEST_COUPON',
  REQUEST_COUPON_SUCCESS: 'REQUEST_COUPON_SUCCESS',
  REQUEST_COUPON_FAILURE: 'REQUEST_COUPON_FAILURE',
  RESET_COUPON_SUCCESS: 'RESET_COUPON_SUCCESS',
  SEND_COUPON_DONE: 'SEND_COUPON_DONE',
  SEND_COUPON_REQUEST: 'SEND_COUPON_REQUEST',

  SET_DESCUENTO_WEB: 'SET_DESCUENTO_WEB',
  RESET_DESCUENTO_WEB: 'RESET_DESCUENTO_WEB'
};

/**
 * Adding partially a discount for these brands, this should be
 * deleted after the campaing
 * @constant {Array<String>} MODELS_WITH_DISCOUNT
 */
export const MODELS_WITHOUT_DISCOUNT = [
  // 'GEOMETRY E',
  // 'OKAVANGO',
  
];

export const CAMPAINGS = {
  '6 meses combustible': '6 meses combustible',
  'dias de locura': 'dias de locura',
  'super cashback': 'super cashback', // Aquí agregamos la nueva campaña
  'banners 0% prima': 'banners 0% prima',
};

export const CAMPAING_METADATA = {
  [CAMPAINGS['dias de locura']]: {
    price: 2000,
    lead: 'DIAS DE LOCURA',
    summaryImage: 'https://veinsamotors.com/wp-content/uploads/2023/06/Banners-web-FINAL.webp',
    stepImage: 'https://veinsamotors.com/wp-content/uploads/2023/06/Banner-Final-2.webp',
  },
  [CAMPAINGS['super cashback']]: {
    price: 'super cashback', 
    lead: 'SUPER CASHBACK',
    summaryImage: 'https://veinsamotors.com/wp-content/uploads/2023/10/1696288576630_298x180.png',
    stepImage: 'https://veinsamotors.com/wp-content/uploads/2023/10/1696288553564_800x112px.png',
  },
  [CAMPAINGS['banners 0% prima']]: {
    price: 'banners 0% prima', 
    lead: 'BANNERS 0% PRIMA',
    summaryImage: 'https://veinsamotors.com/wp-content/uploads/2023/10/Diseno-sin-titulo-9.png',
    stepImage: 'https://veinsamotors.com/wp-content/uploads/2023/10/Dale-clcik.png',
  },
}


export const getCampaingIfApplies = (modelo = '', version = '') => {
  const lowerModel = modelo.toLocaleLowerCase();
  const lowerVersion = version.toLocaleLowerCase();
  const campaingOverrode = Object.keys(CAMPAING_OVERRIDES).find(x => 
    x.toLocaleLowerCase() === lowerModel || lowerVersion === x.toLocaleLowerCase());
  
  if (!campaingOverrode) {
    return null;
  }
  const campaing = CAMPAING_OVERRIDES[campaingOverrode];
  return CAMPAING_METADATA[campaing] || null;
}

export const CAMPAING_OVERRIDES = {
  // 'GX3PROPDGTZG5M2 - 2023': CAMPAINGS['dias de locura'],
  // 'GAZKXXPDGLXG5A2 - 2024': CAMPAINGS['dias de locura'],
  // 'GAZKXXPDGLXG5A2 - 2023': CAMPAINGS['dias de locura'],
  // 
  // 'CC4CXXPEGLSG5A2 - 2024': CAMPAINGS['dias de locura'],
  // 'CC4CXXPEGLXG5A2 - 2024': CAMPAINGS['dias de locura'],
  // 'P3008XPEGLSG5A2 - 2024': CAMPAINGS['dias de locura'],
  // 'P3008XPEGLSG5A2 - 2023': CAMPAINGS['dias de locura'],
  // 'CC4CXXPEGLSG5A2 - 2023': CAMPAINGS['dias de locura'],
  // 'MP1021PIGLXD5M4 - 2024': CAMPAINGS['dias de locura'],
  // 'MP1021PIGLXD5M4 - 2023': CAMPAINGS['dias de locura'],
  // 'C3': CAMPAINGS['dias de locura'],
  'GAZKXXPDGTZG5A4 - 2024': CAMPAINGS['super cashback'],
  'GX3PROPDGTZG5M2 - 2024': CAMPAINGS['super cashback'],
  'GX3PROPDGTZG5A2 - 2024': CAMPAINGS['super cashback'],
  'GX3PROPDGLXG5M2 - 2024': CAMPAINGS['super cashback'],
  'MP1021PIGLXD5M4 - 2024': CAMPAINGS['super cashback'],
  // 'MECR22PHGLSG5A2 - 2023': CAMPAINGS['super cashback'],

  // 'PLTK23PGGTZD5M4 - 2023': CAMPAINGS['te regalamos la prima'],
     'GAZKXXPDGLXG5A2 - 2024': CAMPAINGS['super cashback'],
     'GSX121PXGTZE5A2 - 2024': CAMPAINGS['super cashback'],
     'GSX122PXGTZE5A2 - 2024': CAMPAINGS['super cashback'],
     'GOKA23PDGTZG7A2 - 2024': CAMPAINGS['super cashback'],
     'GOKAXXPDXXZG7A2 - 2024': CAMPAINGS['super cashback'],

     //Autos Nuevos 
     'P3008XPEGLSG5A2 - 2024': CAMPAINGS['super cashback'],
     'PLTK23PGGTZD5M4 - 2023': CAMPAINGS['super cashback'],
     'SJ100XPDGLXG5A4 - 2023': CAMPAINGS['super cashback'],
     'GGEOEV40GTZE5A2 - 2024': CAMPAINGS['super cashback'],
     'SREXXXPIGTZD7A4 - 2024': CAMPAINGS['super cashback'],
     'P5008XPEGTZG7A2 - 2024': CAMPAINGS['super cashback'],
     'MASXXXPHNGXG5A4 - 2024': CAMPAINGS['super cashback'],

     //Nueva campana
     'MECR22PHGLSG5A2 - 2024': CAMPAINGS['super cashback'],
     'MXPA22PDGLSG7A2 - 2024': CAMPAINGS['super cashback'],
     'PP24XXPBGTZG5A2 - 2024': CAMPAINGS['super cashback'],
     'P3008XPEGLSG5A2 - 2024': CAMPAINGS['super cashback'],
     'CC21XXPEGLSG5A2 - 2024': CAMPAINGS['super cashback'],
     'CC4CXXPEGLSG5A2 - 2024': CAMPAINGS['super cashback'],
     'MP1021PIGLXD5M4 - 2024': CAMPAINGS['super cashback'],
}


export const GASOLINE_PROMO_VERSIONS = [
  'CC4CXXPEGLSG5A2',
  'CC21XXPEGLSG5A2',
  'GSX121PXGLSE5A2',
  // 'GOKA23PDGTZG7A2',
  'ML2022PJGLSD5M4',
  'MLHPNWUJGTZD5A4',
  'MNOUTSPHGLSG7A2',
  'MMSPXXPJGTZD7A4',
  'PP24XXPBGLSG5A2',
  'F71TXXUSZZ1D2M2',
  'FE85HXUSZZZD3M2',
  'FE83WXUTZZZD7M2',
  'FFJXXXUVZZZD3M6',
  'PRIFXXUEZZZD7M2',
  // 'MP1021PIGLXD5M4',
  // 'MP1021PIGLXD5M4',
  'CBERXXUEZZZD2M2',
  'CJUMXXUIL2HD2M2',
  'J720XXUMD3TD5M2',
  'J800XXUMZZZD3M2',
  'PEXP21UHZZDD2M2'
];

export const isPartOfGasDiscount = (version, year = null, campaign = null) => {
  if (!campaign || campaign !== CAMPAINGS['6 meses combustible']) {
    return false;
  }
  return GASOLINE_PROMO_VERSIONS.reduce((acc, curr) => {
    if (acc) {
      return acc;
    }
    const splitted = curr.split('/');
    const [versionS, yearS] = splitted;
    return versionS?.toLocaleLowerCase() === version?.toLocaleLowerCase()
      && (!yearS || yearS === year);
  }, false);
}



export const isPartOfModelsWithoutDiscount = (model) => MODELS_WITHOUT_DISCOUNT
  .find(x => x.toLocaleLowerCase() === model.toLocaleLowerCase());

/**
 * @constant {String} ENDPOINT_URL
 */
export const ENDPOINT_URL = /* 'https://stag.veinsamotors.com/'; */
  window.location.hostname.indexOf('localhost') === -1
  ? window.location.origin
  : 'https://veinsamotors-restore-4-prod.azurewebsites.net';

/**
 * @constant {String} VIDEO_CALL_LINK
 */
export const VIDEO_CALL_LINK = 'https://cloud.woxidigital.com/progressiveApp/619264ab06372f561182d9aa/index.jade';

export const MINICUOTAS_NAME = 'AGE CAPITAL MINICUOTAS';
/**
 * @constant {String} TABLET_BREAKPOINT
 */
export const TABLET_BREAKPOINT = 768;

/**
 * @constant {Object} ANIMATIONS
 */
export const ANIMATIONS = {
  bounce: {
    animation: 'x 1s',
    animationName: Radium.keyframes(bounce, 'bounce'),
  },
  fadeIn: {
    animation: 'x 1s',
    animationName: Radium.keyframes(fadeIn, 'fadeIn'),
  },
  slideInDown: {
    animation: 'x 1s',
    animationName: Radium.keyframes(slideInDown, 'fadeIn'),
  },
};

/**
 * Calculates monthly quote
 * @param {Number} calcInteres
 * @param {Number} calcPlazo
 * @param {Number} financingAmount
 * @returns {Number}
 */
export const obtenerCuotaMensual = (
  calcInteres,
  calcPlazo,
  financingAmount
) => {
  const factorInteresNeto = calcInteres / 100;

  /* Use the PMT Excel function - This is the equivalent

  P = (Pv*R) / [1 - (1 + R)^(-n)]

  P = Monthly Payment
  Pv = Present Value (starting value of the loan)
  APR = Annual Percentage Rate
  R = Periodic Interest Rate = APR/number of interest periods per year
  n = Total number of interest periods (interest periods per year * number of years)

  */
  const cuotaMensual =
    (financingAmount * (factorInteresNeto / 12)) /
    (1 - Math.pow(1 + factorInteresNeto / 12, -1 * calcPlazo));
  return cuotaMensual;
};

/**
 * Calculates monthly quote on minicuotas
 * @param {Number} financingAmount
 * @returns {Number}
 */
export const obtenerCuotaMinicuotas = (
  financingAmount,
  financingAmountWithoutPrime,
  quote12,
  secure = 0,
  primeSecure = 0,
  carPrice,
) => {
  const ADM = (financingAmountWithoutPrime * 4.5 / 100) * 1.13;
  const SeguroGPS = 35;
  const GastoOtorg = 11.3;
  const tasa = 18;
  const plazo = 96;
  const costoGps = 20;
  const factorInteresNeto = tasa / 100;

  // const totalAFinanciar = financingAmount + (ADM) + SeguroGPS + GastoOtorg + primeSecure + costoGps;
  let finalFinancing = financingAmount + SeguroGPS + GastoOtorg + costoGps + primeSecure;
  const cuotaMensual =
    (finalFinancing * (factorInteresNeto / 12)) /
    (1 - Math.pow(1 + factorInteresNeto / 12, -1 * plazo));

  if (quote12) {
    const prime = carPrice - financingAmountWithoutPrime;
    return cuotaMensual - ((prime - ADM) / 12) + secure;
  }
  return cuotaMensual + secure;
};

/**
 * Calculates monthly quote
 * @param {Number} price
 * @param {Number} prime
 * @returns {Number}
 */
export const amoutWithoutPrime = (price, prime) =>
  price - price * (prime / 100);

/**
 * @constant {String} VISA
 */
export const VISA = 'VISA';

/**
 * @constant {String} MASTER_CARD
 */
export const MASTER_CARD = 'MASTER_CARD';

/**
 * @constant {String} AMEX
 */
export const AMEX = 'AMEX';

/**
 * @constant{String} DEFAULT_COLOR
 */
export const DEFAULT_COLOR = '#ec1c24';

/**
 * @constant{String} ELECTRIC_COLOR
 */
export const ELECTRIC_COLOR = '#163A8A';

/**
 * @constant{String} ELECTRIC_GRADIENT
 */
export const ELECTRIC_GRADIENT = 'linear-gradient(to right, #2D94CB , #0C136E)';

/**
 * @constant{String} ELECTRIC_TYPE_NAME
 */
export const ELECTRIC_TYPE_NAME = 'Electricos';

/**
 * @constant{String} DEFAULT_FIRST_TYPE
 */
export const DEFAULT_FIRST_TYPE = 'SUV';

/**
 * @constant {Array} SUCURSALES
 */
export const SUCURSALES = [{
    label: 'CURRIDABAT',
    value: 'CURRIDABAT'
  },
  {
    label: 'GUAPILES',
    value: 'GUAPILES'
  },
  {
    label: 'PEREZ ZELEDON',
    value: 'PEREZ ZELEDON'
  },
  {
    label: 'SAN CARLOS',
    value: 'SAN CARLOS'
  },
  {
    label: 'URUCA',
    value: 'URUCA'
  },
  {
    label: 'CITY MALL',
    value: 'CITY MALL'
  },
  {
    label: 'PASEO DE LAS FLORES',
    value: 'PASEO DE LAS FLORES'
  },
  {
    label: 'ESCAZÚ VILLAGE',
    value: 'ESCAZÚ VILLAGE'
  },
  {
    label: 'GEELY URUCA',
    value: 'GEELY URUCA'
  },
  {
    label: 'GEELY CURRIDABAT',
    value: 'GEELY CURRIDABAT'
  }
];

/**
 * @constant {Array} DEFAULT_TOUR
 */
export const DEFAULT_TOUR =
  'https://my.matterport.com/show/?m=VzULdnwFxJS&lang=es&play=1';

export const METAS = {
  "hatchback": {
    "keywoard": "cotizador de autos nuevos cotizar autos nuevos precios de carros nuevos",
    "title": "Cotizador de Autos Nuevos - Veinsa Motors",
    "description": "Ingresá a nuestro cotizador de autos nuevos. Encontrá precios de carros nuevos de  todas nuestras marcas y calculá la cuota del carro que elijás"
  },
  "mirage": {
    "keywoard": "mitsubishi mirage precio",
    "title": "Mitsubishi Mirage Precio - Veinsa Motors",
    "description": "Encontrá aquí todos los detalles del Mitsubishi Mirage y su precio. Elegí todas las características que querás y encontrá opciones de finanaciamiento"
  },
  "c3": {
    "keywoard": "citroen c3 costa rica precio",
    "title": "Citroen C3 en Costa Rica y Su Precio - Veinsa Motors",
    "description": "Llegó el Citroen C3 a Costa Rica, encontrá aquí su precio y todos los detalles. Elegí el color, seguro, financiamiento y más. El precio lo tendrás en minutos."
  },
  "208": {
    "keywoard": "peugeot 208 precio costa rica",
    "title": "Peugeot 208  y Su Precio en Costa Rica  - Veinsa Motors",
    "description": "Encontrá aquí el Peugeot 208 y su precio en Costa Rica. Elegí todos los detalles que mejor se adapten a tus necesidades y cotizá sin salir de tu casa."
  },
  "sedan": {
    "keywoard": "carro sedan sedan precio",
    "title": "Carro sedán Precio - Veinsa Motors",
    "description": "Aquí podés elegir el carro sedán que más se adapte a vos. Obtené el precio sin tener que salir de tu casa. "
  },
  "mirage g4": {
    "keywoard": "mitsubishi mirage g4 precio",
    "title": "Mitsubishi Mirage G4 Precio - Veinsa Motors",
    "description": "Te presentamos el Mitsubishi Mirage G4 y su precio. Cotizar es my simple, elegí las características a tu gusto y listo."
  },
  "c-elysee": {
    "keywoard": "citroen c elysee precio",
    "title": "Citroen C Elysee Precio - Veinsa Motors",
    "description": "Encontrá el Citroen C-Elysee y su precio. Aquí podés elegir accesorios, mantenimiento, seguros e incluso el financiamiento"
  },
  "301": {
    "keywoard": "peugeot 301 precio",
    "title": "Peugeot 301 Precio - Veinsa Motors",
    "description": "Encontrá aquí todos los detalles de el Peugeot 301 y su precio. Podés cotizar de forma inmediata en este link."
  },
  "gc6": {
    "keywoard": "geely gc6 precio",
    "title": "Geely GC6 Precio - Veinsa Motors",
    "description": "Elegí todos los detalles que querás, personalizá tu Geely GC6 y obtené su precio. Es simple, solamente seguí los pasos."
  },
  "emgrand 7": {
    "keywoard": "precio emgrand 7",
    "title": "Precio Emgrand 7 - Veinsa Motors",
    "description": "Encontrá aquí el precio del Emgrand 7. Personalizalo con accesorios, escogé el seguro y mucho más con pocos clics."
  },
  "suv": {
    "keywoard": "suv a buen precio",
    "title": "Cotizador de  Autos Nuevos Costa Rica - Veinsa Motors",
    "description": "Cotizá tu SUV en Costa Rica aquî. Elegí el color y modelo que mejor se adapte a vos y obtené el precio sin salir de tu casa."
  },
  "test-drive": {
    "keywoard": "veinsa motors test drive",
    "title": "Test Drive Costa Rica - Veinsa Motors",
    "description": "Solicitá hoy mismo tu test drive en Veinsa Motors y descubrí por qué nuestras marcas son las mejores. "
  },
  "pickup/L200": {
    "keywoard": "veinsa motors test drive",
    "title": "Cotizador de Pick Up Costa Rica - Veinsa Motors",
    "description": "Cotizá tu pick up en Costa Rica aquí. Elegí el color y modelo que mejor se adapte a vos y obtené el precio sin salir de tu casa."
  },
  "asx": {
    "keywoard": "mitsubishi asx precio costa rica",
    "title": "Mitsubishi ASX Precio Costa Rica - Veinsa Motors",
    "description": "¿Buscás el Mitsubishi ASX y su precio en Costa Rica? Ingresá y personalizá tu carro, cotizá en pocos clics."
  },
  "outlander sport": {
    "keywoard": "precio outlander sport",
    "title": "Precio del Outlander Sport - Veinsa Motors",
    "description": "En Veinsa Motors podés obtener el precio del Outlander Sport en tan solo unos clics y sin tener que salir de tu casa"
  },
  "eclipse cross": {
    "keywoard": "mitsubishi cross eclipse precio mitsubishi eclipse cross precio costa rica",
    "title": "Mitsubishi Eclipse Cross Precio Costa Rica - Veinsa Motors",
    "description": "Cotizador de Autos Nuevos - Veinsa Motors"
  },
  "outlander": {
    "keywoard": "mitsubishi outlander precio",
    "title": "Mitsubishi Outlander Precio - Veinsa Motors",
    "description": "Aquí podés personalizar tu MItsubishi Outlander y obtener su precio a tan solo unos cuantos clics desde tu casa"
  },
  "sport": {
    "keywoard": "mitsubishi montero sport precio",
    "title": "Mitsubishi Montero Sport Precio - Veinsa Motors",
    "description": "Encontrá el Mitsubishi Montero Sport y su precio. Elegí las características de tu carro y cotizá al instante"
  },
  "outlander phev": {
    "keywoard": "precio outlander phev",
    "title": "Precio del Outlander PHEV - Veinsa Motors",
    "description": "Ingresá aquí y obtené el precio del Outlander PHEV. Simplemente ingresá y personalizá tu carro y listo."
  },
  "pickup": {
    "keywoard": "que pick up comprar comprar pick up",
    "title": "Comprar Pick Up - Veinsa Motors",
    "description": "¿Estás buscando qué pick up comprar? Ingresá aquí y elegí entre todas nuestras marcas. Cotizá al instante"
  },
  "microbus": {
    "keywoard": "microbus precio venta de microbuses en costa rica",
    "title": "Venta de Microbuses en Costa Rica - Veinsa Motors",
    "description": "Ingresá a la sección de venta de microbuses en Costa Rica y encontrá lo mejor en microbuses y su precio."
  },
  "rosa": {
    "keywoard": "precio mitsubishi fuso rosa",
    "title": "Precio de Microbus JMC N520 - Veinsa Motors",
    "description": "Ingresá y obtené el precio de la Microbus JMC N520 al instante. Escogé los accesorios, color, seguros y más, todo sin salir de tu casa."
  },
  "n520": {
    "keywoard": "microbus jmc ",
    "title": "Precio Mitsubishi Fuso Rosa - Veinsa Motors",
    "description": "Encontrá el precio del Mitsubishi Fuso Rosa, podés ver todas las características y cotizar sin salir de tu casa"
  },
  "tivoli": {
    "keywoard": "ssangyong tivoli precio",
    "title": "Ssangyong Tivoli Precio - Veinsa Motors",
    "description": "Encontrá aquí todas las características del Ssangyong Tivoli y su precio. Cotizá al instante sin salir de tu casa."
  },
  "rexton": {
    "keywoard": "ssangyong rexton precio",
    "title": "Sssangyong Rexton Precio - Veinsa Motors",
    "description": "Ingresá y descubrí todas las características del Ssangyong Rexton y su precio. Podés cotizar al instante."
  },
  "c5 aircross": {
    "keywoard": "citroen c5 aircross precio citroen c5 aircross precio costa rica",
    "title": "Citroen C5 Aircross Precio Costa Rica - Veinsa Motors",
    "description": "Ingresá para obtener el Citroen C5 Aircross y su precio. Elegí los detalles que más te gustan y cotizá de inmediato."
  },
  "2008": {
    "keywoard": "peugeot 2008 precio peugeot 2008 precio costa rica",
    "title": "Peugeot 2008 Precio Costa Rica - Veinsa Motors",
    "description": "Encontrá aquí el Peugeot 2008 y su precio. Ingresá al cotizador y elegí las características y obtené la información de inmediato."
  },
  "3008": {
    "keywoard": "peugeot 3008 costa rica precio peugeot 3008 precio",
    "title": "Peugeot 3008 Precio Costa Rica - Veinsa Motors",
    "description": "En nuestro cotizador encontrá el Peugeot 3008 y su precio. Ingresá ya y cotizá al instante, sin necesidad de visitarnos."
  },
  "5008": {
    "keywoard": "peugeot 5008 precio costa rica",
    "title": "Peugeot 5008 Precio Costa Rica - Veinsa Motors",
    "description": "Ingresá a nuestro cotizador y encontrá el Peugeot 5008 y su precio en Costa Rica. No tenés que salir de tu casa, obtendrás tu cotización al instante."
  },
  "gx3": {
    "keywoard": "geely gx3 costa rica precio geely gx3 precio",
    "title": "Geely GX3 Costa Rica Precio - Veinsa Motors",
    "description": "En nuestro cotizador podés obtener las características del Geely GX3 y su precio. Elegí las características que mejor se adapten a vos y cotizá al instante."
  },
  "xuv300": {
    "keywoard": "mahindra XUV300 precio",
    "title": "Mahindra XUV300 Precio - Veinsa Motors",
    "description": "Ingresá y encontrá el Mahindra XUV300 y su precio. En nuestro cotizador podés personalizar el modelo y cotizar al instante"
  },
  "canter fe84": {
    "keywoard": "fuso canter fe84 precio",
    "title": "Fuso Canter FE84 - Veinsa Motors",
    "description": "Ingresà a nuestro cotizador y podés cotizar al instante. Encontrá las características del Fuso Canter FE84 y su precio."
  },
  "canter fi": {
    "keywoard": "fuso canter fi",
    "title": "Fuso Canter FI - Veinsa Motors",
    "description": "Ingresá y encontrá las características que más te gusten para tu Fuso Canter F1 y su precio."
  },
  "_": {
    "keywoard": "Cotizador de Autos Nuevos - Veinsa Motors",
    "title": "Cotizador de Autos Nuevos - Veinsa Motors",
    "description": "Cotizador de Autos Nuevos - Veinsa Motors"
  }
};

export const GATEWAY_KEYS = {
  CHECKOUT: 'checkout_public_nfxZ7TATbaXk633H8f5jf2bUGCj5D7r8',
  KEY_ID: 14202497,
  Tokenization: 'YxGGA2-WWypns-kHDKdH-t25ZmW',
  Tokenization_Key_ID: 14202499,
};

export const RESERVATION_FEE = 500; //usd